import {
    conferenceFailed,
    conferenceWillJoin,
    getMediaServerInfo
} from "../../features/base/conference";
import { connectionDisconnect } from "../../features/base/connection";
import {
    initLib,
    isFatalJitsiConnectionError,
    JitsiConferenceErrors,
    JitsiConnectionEvents
} from "../../features/base/lib-jitsi-meet";
import { getParticipantCount } from "../../features/base/participants";
import { disposeAndRemoveTracks, getLocalTracks, getTrackState } from "../../features/base/tracks";
import jitsiConnection, { default as connection } from "./connection";
import deviceManager from "./device";

import { getConferenceOptions } from "../../features/conference/functions";
import { JitsiOptions } from "../../features/config/jitsiConfig";
import { showErrorNotification } from "../../features/notifications";
import roomListener from "./roomListener";
import screenShare from "./screenSharing";

class jitsiServer {
    constructor() {
        this._localTracksInitialized = false;

        this.connection = null;
        this.conference = null;

        this.deviceManager = deviceManager;
        this.jitsiConnection = jitsiConnection;
        this.screenShareManager = screenShare;
        this.roomListener = roomListener;
    }

    getRoom() {return this.conference;}

    init() {
        APP.store.dispatch(initLib());
        const handler = {
            _localTracksInitialized: this.getLocalTracksInitialized.bind(this),
            getRoom: this.getRoom.bind(this),
            getMyUserId: this.getMyUserId(this)
        }
        this.deviceManager.init(handler);

        this.jitsiConnection.init({
            setConnect: this.setConnect.bind(this),
            enterRoom: this.enterRoom.bind(this)
        });

        this.screenShareManager.init({
            createDesktopTrack: this.createDesktopTrack.bind(this)
        });
    }

    setConnect = connection => {
        this.connection = connection;
    }

    unload() {
        this.conference && this.conference.leave();
    }

    getReducerState(action) {
        switch (action) {
            case "connection":
                return APP.store.getState()['features/base/connection'];
            case "tracks":
                return APP.store.getState()['features/base/tracks'];
            case "conference":
                return APP.store.getState()['features/base/conference'];
            default:
                return false;
        }
    }

    /**
     * Connetcion
     */
    connect() {        
        try {
            const roomUUID = APP.mateManagement.getRoom('uuid');

            const connectionConfig = Object.assign({}, JitsiOptions.connectOptions);
            const media_server_info = getMediaServerInfo(APP.store.getState());
            const serviceUrl = `wss://${location.host}${media_server_info.url}`;// connectionConfig.serviceUrl + `?room=${roomUUID}`;
            connectionConfig.serviceUrl = serviceUrl;

            if (connectionConfig.websocketKeepAliveUrl) {
                connectionConfig.websocketKeepAliveUrl += `${media_server_info.url}`;;
            }
            connection.connect(connectionConfig);
        } catch (err) {
            console.log(err);
            this.disconnect();
        }        
    }
    
    async disconnect() {
        const state = APP.store.getState();

        const tracks = getTrackState(state);
        await APP.store.dispatch(disposeAndRemoveTracks(getLocalTracks(tracks).map(t => t.track) ));

        if (this.conference && this.conference.isJoined()) {
            return this.conference.leave().then(connectDisconnect, connectDisconnect);
        }
        
        return connectDisconnect();
    }

    /**
     * DEVICE 장치 설정 
     */
    async initDevice(setDeviceListChangeHandler) {
        const result = await this.deviceManager.setInitDevice(setDeviceListChangeHandler);

        return result;
    }
    // 스피커 설정
    setAudioOutputDevice(newId) {
        return this.deviceManager.setAudioOutputDevice(newId);
    }
    getAudioOutputDeviceId() {
        return this.deviceManager.getAudioOutputDeviceId();
    }
    
    // CREATE LOCAL TRACK 
    initLocalTrack(options) {
        return this.deviceManager.createInitialLocalTracks(options);
    }
    createLocalTracks(options) {
        return this.deviceManager.createLocalTracksF(options);
    }
    // CREATE LOCAL TRACK 재시도 
    createLocalTrackA(options) {
        return this.deviceManager.createLocalTracksA(options);
    }
    // desktop track 생성
    createDesktopTrack(options) {
        return this.deviceManager._createDesktopTrack(options);
    }
    // TRACK 저장
    trackAdded(track) {
        return this.deviceManager.trackAdded(track);
    }
    // TRACK 파괴
    disposeTracks(tracks) {
        return this.deviceManager.disposeTracks(tracks);
    }
    // TRACK 음소거 
    setTrackMuted(track, muted) {
        return this.deviceManager.setTrackMuted(track, muted);
    }

    /**
     * CONFERENCE 장치 설정 
     */
    // REPLACE TRACK 
    replaceConferenceTrack(oldTrack, newTrack) {
        return this.deviceManager.replaceConferenceTrack(oldTrack, newTrack);
    }

    /**
     * 화면 공유
     */
    toggleScreenShare(toggle) {
        this.screenShareManager.toggleScreenSharing(toggle);        
    }
    screenConnect() {
        this.screenShareManager.screenConnect();
    }
    getLocalTracksInitialized() {
        return this._localTracksInitialized;
    }
    getScreenSharing() {
        return this.screenShareManager.isScreenSharing();
    }

    /**
     * CONFERENCE
     */
    enterRoom() {
        const roomName = APP.mateManagement.getRoom('code')

        if (!this.connection) {
            throw new Error(`Cannot create a conference without a connection!`);
        }

        const options = getConferenceOptions(APP.store.getState());
        this.conference = this.connection.initJitsiConference(roomName, options);  

        this._localTracksInitialized = true;
        this.connection.addEventListener(JitsiConnectionEvents.CONNECTION_FAILED, _connectionFailedHandler);
        
        this._conferenceWillJoin();

        this.roomListener.init(this.conference, this.deviceManager);

        this.conference.join();
    }

    async _conferenceWillJoin() {
        const { getState, dispatch } = APP.store;

        const track = getState()['features/base/tracks'];
        const localTracks = getLocalTracks(track).map(t => t.track) || [];
        
        dispatch(conferenceWillJoin(this.conference, APP.mateOption.mediaServer));

        this.addLocalTracksToConference(localTracks);
    }

    addLocalTracksToConference(localTracks) {   
        this.deviceManager.addLocalTracksToConference(localTracks);
    }
    removeLocalTracksFromConference(localTracks) {
        this.deviceManager.removeLocalTracksFromConference(localTracks, this.conference);
    }
    listenForAudioLevelUpdates(track) {
        this.deviceManager.listenForAudioUpdates(track);
    }
    removeForAudioLevelUpdates(track) {
        this.deviceManager._stopListenForAudioUpdates(track);
    }

    _getConferenceOptions() {
        return getConferenceOptions(APP.store.getState());
    }

    _setupListeners() {
                 
    };

    isLocalId(id) {
        return this.getMyUserId() === id;
    }
    getMyUserId() {
        return this.conference && this.conference.myUserId();
    }

    getConferenceFailedErr(error, room) {
        let authRequired;
        let membersOnly;
        let passwordRequired;

        switch (error.name) {
            case JitsiConferenceErrors.AUTHENTICATION_REQUIRED:
                authRequired = room;
                break;
    
            case JitsiConferenceErrors.CONFERENCE_ACCESS_DENIED:
            case JitsiConferenceErrors.MEMBERS_ONLY_ERROR:
                membersOnly = room;
                break;
        } 
    
        return {
            authRequired,
            conference: undefined,
            e2eeSupported: undefined,
            error,
            joined: undefined,
            leaving: undefined,
            membersOnly,
            password: undefined,
            passwordRequired
        };
    }

    sendActionMessage(data) {
        try {
            if (getParticipantCount(APP.store.getState()) > 1) {
                this.conference.sendEndpointMessage('', data);
            }
        } catch (e) {
            console.log(e)
            // this.sendData(data.type, data.data);
        }
    }

    sendData(command, value) {
        if (!room) {
            return;
        }
    
        this.conference.removeCommand(command);
        this.conference.sendCommand(command, { value });
    }

    toggleVideoMuted(showUI) {
        this.deviceManager.toggleVideoMuted(showUI);
    }

    toggleAudioMuted(showUI) {
        this.deviceManager.toggleAudioMuted(showUI);
    }
}

const jitsi = new jitsiServer();
export default jitsi;

function _connectionFailedHandler(error) {
    if (isFatalJitsiConnectionError(error)) {
        APP.connection.removeEventListener(
            JitsiConnectionEvents.CONNECTION_FAILED,
            _connectionFailedHandler);
        if (room) {
            APP.store.dispatch(conferenceWillLeave(room));
            room.leave();
        }
    }
}

function connectDisconnect() {
    const onDisconnected = () => {   
        return Promise.resolve();
    };

    if (!connection) {
        return onDisconnected();
    }
    
    // return connection?.disconnect(); //.then(onDisconnected, onDisconnected);
}

function _conferenceFailed(room, error) {
    const { dispatch, getState } = APP.store;
    // const { enableForcedReload } = getState()['features/base/config'];

    switch (error.name) {
        case JitsiConferenceErrors.CONFERENCE_DESTROYED: {
            const [ reason ] = error.params;

            dispatch(showErrorNotification({
                description: reason,
                titleKey: 'dialog.sessTerminated'
            }));

            break;
        }
        case JitsiConferenceErrors.CONFERENCE_RESTARTED: {
            // if (enableForcedReload) {
                dispatch(showErrorNotification({
                    description: 'Restart initiated because of a bridge failure',
                    titleKey: 'dialog.sessionRestarted'
                }));
            // }

            break;
        }
        case JitsiConferenceErrors.CONNECTION_ERROR: {            
            const [ msg ] = error.params;

            dispatch(connectionDisconnect(getState()['features/base/connection'].connection));

            break;
        }
        case JitsiConferenceErrors.OFFER_ANSWER_FAILED:
            sendAnalytics(createOfferAnswerFailedEvent());
            break;
        }

        if (typeof APP === 'undefined') {
            !error.recoverable
            && room
            && room.leave().catch(reason => {
                logger.info('JitsiConference.leave() rejected with:', reason);
            });
        } else if (typeof beforeUnloadHandler !== 'undefined') {
            window.removeEventListener('beforeunload', beforeUnloadHandler);
            beforeUnloadHandler = undefined;
        }

        if (error?.name === JitsiConferenceErrors.CONFERENCE_RESTARTED) {
            dispatch(reloadNow());
        }

    return dispatch(conferenceFailed(room, error));
}